import React, { useState } from 'react';
import { useConfig, useConfigJapanese } from '../../contexts/ConfigContext';
import { IconSvg } from '../IconSvg';
import { MobileMenu } from '../MobileMenu';
import { GojuonChart } from '../GojuonChart';
import { TranslateService } from '../../services/japanese';
import { TranslateServiceContent } from '../TranslateServiceSelector';
import { useIsMobile } from '../../hooks/useIsMobile';
import './style.css';

interface SettingsProps {
  isDetailOpen?: boolean;
}

export const Settings: React.FC<SettingsProps> = ({ isDetailOpen }) => {
  const { config, setConfig, resetConfig } = useConfig();
  const { config: japaneseConfig, updateConfig: updateJapaneseConfig, resetConfig: resetJapaneseConfig } = useConfigJapanese();
  const [showSettings, setShowSettings] = useState(false);
  const [showResetConfirm, setShowResetConfirm] = useState(false);
  const [showGojuon, setShowGojuon] = useState(false);
  const isMobile = useIsMobile();

  // 处理重置配置
  const handleResetConfig = () => {
    resetConfig();
    resetJapaneseConfig();
    setShowResetConfirm(false);
  };

  return (
    <>
      {/* 右上角按钮组，在移动端或详情页面打开时隐藏 */}
      {!isMobile && !isDetailOpen && (
        <div className="settings-container">
          {/* 五十音图按钮 */}
          <button
            className="settings-button"
            onClick={() => setShowGojuon(true)}
            title="五十音图"
          >
            <span style={{ fontSize: '14px', fontWeight: 500 }}>音</span>
          </button>

          {/* 主题切换按钮 */}
          <button
            className="settings-button"
            onClick={() => setConfig({ ...config, theme: config.theme === 'light' ? 'dark' : 'light' })}
            title={config.theme === 'light' ? "切换到暗色模式" : "切换到亮色模式"}
          >
            <IconSvg
              name={config.theme === 'light' ? 'ph:moon-stars' : 'ph:sun'}
              width={20}
              height={20}
            />
          </button>

          {/* 设置按钮 */}
          <button
            className="settings-button"
            onClick={() => setShowSettings(true)}
            title="设置"
          >
            <IconSvg name="mdi:cog" width={20} height={20} />
          </button>
        </div>
      )}

      {/* 设置面板 */}
      <MobileMenu
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
        title="设置"
      >
        <div className="settings-panel">
          <div className="settings-content">
            <div className="settings-section">
              <h3>显示设置</h3>
              <div className="settings-item">
                <label className="settings-label">
                  <input
                    type="checkbox"
                    checked={config.showHiragana}
                    onChange={(e) => setConfig({ ...config, showHiragana: e.target.checked })}
                  />
                  <span>显示假名标注</span>
                </label>
              </div>
              <div className="settings-item">
                <label className="settings-label">
                  <input
                    type="checkbox"
                    checked={config.showRomaji}
                    onChange={(e) => setConfig({ ...config, showRomaji: e.target.checked })}
                  />
                  <span>显示罗马音</span>
                </label>
              </div>
              <div className="settings-item">
                <label className="settings-label">
                  <input
                    type="checkbox"
                    checked={config.showTraditional}
                    onChange={(e) => setConfig({ ...config, showTraditional: e.target.checked })}
                  />
                  <span>显示繁体中文</span>
                </label>
              </div>
            </div>

            {/* 翻译服务设置 */}
            <div className="settings-section">
              <h3>翻译服务</h3>
              <div className="settings-service-options">
                <TranslateServiceContent
                  service={japaneseConfig.translateService}
                  onChange={(service: TranslateService) => {
                    updateJapaneseConfig({ translateService: service });
                    setShowSettings(false);
                  }}
                />
              </div>
            </div>

            {/* 重置按钮 */}
            <div className="settings-section">
              <button
                className="reset-button"
                onClick={() => setShowResetConfirm(true)}
              >
                重置所有设置
              </button>
            </div>
          </div>
        </div>
      </MobileMenu>

      {/* 重置确认对话框 */}
      {showResetConfirm && (
        <div className="reset-confirm-overlay">
          <div className="reset-confirm-dialog">
            <div className="reset-confirm-content">
              <p>确定要重置所有设置吗？此操作无法撤销。</p>
              <div className="reset-confirm-buttons">
                <button
                  className="reset-confirm-button cancel"
                  onClick={() => setShowResetConfirm(false)}
                >
                  取消
                </button>
                <button
                  className="reset-confirm-button confirm"
                  onClick={handleResetConfig}
                >
                  确定重置
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 五十音图 */}
      <GojuonChart
        isOpen={showGojuon}
        onClose={() => setShowGojuon(false)}
      />
    </>
  );
};